export class FileBase {
    public fileName: string;
    public mimeType: string;
    public fileData: string;
}